import http from '../../../../../libs/http'
export default (queryParams = {}) =>
  http.get(`${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/credit-lines`, { params: { ...queryParams } })
